export const EmailSetupStep = {
    ADD_EMAIL: 'add-email',
    NAME_INBOX: 'name-inbox',
} as const;
export type EmailSetupStep = (typeof EmailSetupStep)[keyof typeof EmailSetupStep];
